export default {
  cancelText: 'Cancel',
};
